import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './styles.scss'
import { CSSTransition } from 'react-transition-group'

const NavItem = ({ label, route, hasDropDown = false, options = [] }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const isActive = location.pathname === route

  const handleClick = () => navigate(route)

  const onMenuItemSelected = (e, value) => {
    e.stopPropagation()
    navigate(route, { state: { service: value } })
    setIsMenuOpen(false)
  }

  return (
    <div
      className="nav-item"
      onClick={handleClick}
      onMouseEnter={() => hasDropDown && setIsMenuOpen(true)}
      onMouseLeave={() => hasDropDown && setIsMenuOpen(false)}
    >
      <span className={isActive ? 'active' : undefined}>
        {label}{' '}
        {hasDropDown && (
          <FontAwesomeIcon
            className={`icon ${isMenuOpen ? 'open' : ''}`}
            icon={solid('chevron-down')}
          />
        )}
      </span>

      {hasDropDown && (
        <NavItemMenu
          isMenuOpen={isMenuOpen}
          options={options}
          handleClick={onMenuItemSelected}
        />
      )}
    </div>
  )
}

const NavItemMenu = ({ isMenuOpen, options, handleClick }) => {
  const menuRef = useRef(null)

  return (
    <CSSTransition
      classNames="nav-item-menu"
      in={isMenuOpen}
      timeout={300}
      unmountOnExit
      nodeRef={menuRef}
    >
      <div
        ref={menuRef}
        className="nav-item-menu"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="nav-item-menu__container">
          {options.map((option) => (
            <div
              className="option"
              key={option}
              onClick={(e) => handleClick(e, option)}
            >
              {option}
            </div>
          ))}
        </div>
      </div>
    </CSSTransition>
  )
}

export default NavItem
